import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ResponsePackage } from '../models/util.model';
import {
  AddNewSectionDefinitionDto,
  SectionDefinition,
  SectionInstance,
} from '../models/section-definition.model';
import { Observable } from 'rxjs';
import { Guid } from 'typescript-guid';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root',
})
export class SectionDefinitionService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'sectionDefinition/';
  }

  getAllForSelect(obj: any) {
    return this.http.post<ResponsePackage<SectionDefinition[]>>(
      `${this.pathApi}getAll`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }

  save(sectionDefinition: AddNewSectionDefinitionDto, utilityId?: number | null): Observable<any> {
    let url = `${this.pathApi}save`;
    if (utilityId !== null && utilityId !== undefined) {
      url += `/${utilityId}`;
    }

    return this.http.post(url, sectionDefinition, {
      observe: 'response',
    });
  }

  updateOrder(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}updateOrder`, obj, {
      observe: 'response',
    });
  }

  delete(id: number, utilityId: number | null = null): Observable<any> {
    if(utilityId == null){
      return this.http.delete(`${this.pathApi}delete/` + id , {
        observe: 'response',
      });  
    }
    return this.http.delete(`${this.pathApi}delete/` + id + '/' + utilityId, {
      observe: 'response',
    });
  }

  downloadSectionDefinition(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}downloadFile`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAllSectionDefinitionsForDmc(entityType: number, utilityId?: number | null, substationTemplateId?: number | null, equipmentType?: number | null) {
    let url = `${this.pathApi}getAllSectionDefinitionsForDmc/${entityType}`;
    if (utilityId !== null && utilityId !== undefined) {
      url += `/${utilityId}`;
    }

    const params: any = {};
    if (substationTemplateId !== null && substationTemplateId !== undefined) {
      params.substationTemplateId = substationTemplateId;
    }
    
    if (equipmentType !== null && equipmentType !== undefined) {
      params.equipmentType = equipmentType;
    }

    return this.http.get<ResponsePackage<SectionDefinition[]>>(url, {
      headers: this.headers,
      observe: 'response',
      params
    });
  }

  createIfNotExist(dataIn: any, utilityId: number): Observable<any> {
    return this.http.post(`${this.pathApi}createIfNotExist/${utilityId}`, dataIn, {
      headers: this.headers,
      observe: 'response',
    })
  }

}
